import React, { useState } from "react"
import { FlexContainer } from "@carrotfertility/carotene"
import { BodySmall } from "./views/atoms/Bodies"
import { CompleteFormTextArea } from "./views/atoms/forms/FormTextArea"
import L10n from "../lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

function useMaxLength({ maxLength, onChange }) {
  const [lengthWarningMessage, setLengthWarningMessage] = useState(null)
  function validateMaxLength(value) {
    onChange && onChange(value)
    setLengthWarningMessage(value.length >= maxLength * 0.75 ? `${value.length} / ${maxLength}` : null)
  }
  return { validateMaxLength, lengthWarningMessage, maxLength }
}

const InternationalAddress = ({ label, onChange, nonUsaAddress, register, errors }) => {
  const { validateMaxLength, lengthWarningMessage, maxLength } = useMaxLength({ maxLength: 500, onChange })

  return (
    <>
      <CompleteFormTextArea
        {...{
          name: "nonUsaAddress",
          label: label,
          placeholder: l`client.accountSettings.nonUsaAddressPlaceholder`,
          defaultValue: nonUsaAddress,
          maxLength,
          onChange: (e) => validateMaxLength(e.target.value),
          showValidation: false,
          ref: register,
          errors: errors
        }}
      />
      <FlexContainer justifyContent="flex-end" stack="huge">
        {lengthWarningMessage && <BodySmall color="black-60">{lengthWarningMessage}</BodySmall>}
      </FlexContainer>
    </>
  )
}

export { InternationalAddress }
